import React, { useEffect, useState, createContext, useContext, useRef } from "react";
import { NavLink, Link } from "react-router-dom";
import foot_Logo from "../../img/logol.png";
import head_Logo from "../../img/Riu_TM_Logo.png";
import { apiCall } from "../../_services/apiCall";
import "./common.css";
import "./sidebar.css";
import config from "../../config/config.json";
import { PermissionMenuContext } from "../../contextApi/permissionBasedMenuContext";
import { authenticationService } from "../../_services/authentication";
import { history } from "../../_helpers/history";
import { FiClipboard, FiLogOut, FiSidebar, FiMessageCircle, FiBarChart2 } from "react-icons/fi";
import { set } from "lodash";
import down from "../../img/DownArrow.svg";

const LockIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

export const AuditContext = createContext();
export const useAudit = () => useContext(AuditContext);
let selectedItem = ""
export const AuditProvider = ({ children }) => {
  const [auditModuleNames, setAuditModuleNames] = useState([]);
  const [auditModule, setAuditModule] = useState([]);
  const [auditAssignedTo, setAuditAssignedTo] = useState([]);
  const isMounted = useRef(true);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    getAuditListing()
  }, [])

    const getFinancialYear = async () => {
      try {
        // Check if data exists in local storage
        const storedData = localStorage.getItem('financialYearData');
        
        if (storedData) {
          // Data exists in local storage, parse and use it
          const parsedData = JSON.parse(storedData);
          const lastEntry = parsedData[parsedData.length - 1];
          return lastEntry.id;
        } else {
          // Data not in local storage, call API
          const { isSuccess, data } = await apiCall(
            `${config.POSTLOGIN_API_URL_COMPANY}getFinancialYear`,
            {},
            {}
          );
          
          if (isSuccess && isMounted.current) {
            // Store the response in local storage for future use
            localStorage.setItem('financialYearData', JSON.stringify(data.data));
            
            const lastEntry = data.data[data.data.length - 1];
            return lastEntry.id;
          }
        }
      } catch (error) {
        console.error("Error fetching financial year:", error);
      }
    };


  const getAuditListing = async () => {
    let url = window.location.href;
    if (url.includes("audit-listing")) {
      try {
        const response = await apiCall(
          `${config.POSTLOGIN_API_URL_COMPANY}getAuditListing`,
          {},
          {
            financialYearId: await getFinancialYear() 
            // frameworkIds: [1] 
          },
          "GET"
        );
        if (response.isSuccess && isMounted.current) {
          const data = response.data;

          // Set to collect unique module names
          const moduleNamesSet = new Set();

          // Object to group data by module
          const groupedData = data?.data?.reduce((acc, item) => {
            const moduleName = item.question?.moduleName || "Unknown Module";

            // Add module name to the set
            moduleNamesSet.add(moduleName);

            // Initialize array if not already done
            if (!acc["All Module"]) {
              acc["All Module"] = [];
            }
            acc["All Module"].push(item);
            if (!acc[moduleName]) {
              acc[moduleName] = [];
            }

            // Add item to the module's array
            acc[moduleName].push(item);
            return acc;
          }, {});

          const moduleNamesList = Array.from(moduleNamesSet);

          if (isMounted.current) {
            setAuditModule(groupedData);
          }

          setAuditModuleNames(moduleNamesList);

          const assignedToData = data.getAssignedDetails

          setAuditAssignedTo(assignedToData);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  return (
    <AuditContext.Provider value={{ getAuditListing, auditModule, auditModuleNames, auditAssignedTo }}>
      {children}
    </AuditContext.Provider>
  );
};
const Sidebar = ({ onSidebarToggle }) => {
  const contextType = useContext(PermissionMenuContext);
  const [menuList, setMenuList] = useState([]);
  const [frameworkValue, setFrameworkValue] = useState([]);
  const [moduleNames, setModuleNames] = useState([]);
  const [module, setModule] = useState([]);
  const [isSubmenuVisible, setIsSubmenuVisible] = useState(false);
  const [assignedTo, setAssignedTo] = useState([]);
  const [isAuditSubmenuVisible, setIsAuditSubmenuVisible] = useState(false);
  const [isAuditListingSubmenuVisible, setIsAuditListingSubmenuVisible] = useState(false);
  const [auditModuleNames, setAuditModuleNames] = useState([]);
  const [auditModule, setAuditModule] = useState([]);
  const [auditAssignedTo, setAuditAssignedTo] = useState([]);
  const [sourceData, setSourceData] = useState();
  const [isRotated, setIsRotated] = useState(false);
  const [isAuditRotated, setIsAuditRotated] = useState(
    () => JSON.parse(localStorage.getItem("subAuditMenu") ?? "false")
  );
  const [isCarbonRotated, setIsCarbonRotated] = useState(
    () => JSON.parse(localStorage.getItem("subCarbonMenu") ?? "false")
  );
  const [isSubmenuOpen, setIsSubmenuOpen] = useState(false);
  const [isCarbonSubMenuVisible, setIsCarbonSubMenuVisible] = useState(
    () => JSON.parse(localStorage.getItem("subCarbonMenu") ?? "false")
  );
  const [hasMoreScroll, setHasMoreScroll] = useState(false);

  const isMounted = useRef(true);
  const menuScrollRef = useRef(null);
  const activeMenuRef = useRef(null);

  useEffect(() => {
    const el = menuScrollRef.current;
    if (!el) return;
    const check = () => {
      setHasMoreScroll(el.scrollHeight - el.scrollTop > el.clientHeight + 4);
    };
    check();
    el.addEventListener("scroll", check);
    return () => el.removeEventListener("scroll", check);
  }, [menuList]);

  useEffect(() => {
    if (activeMenuRef.current && menuScrollRef.current) {
      const container = menuScrollRef.current;
      const item = activeMenuRef.current;
      const itemTop = item.offsetTop;
      const itemBottom = itemTop + item.offsetHeight;
      const containerTop = container.scrollTop;
      const containerBottom = containerTop + container.clientHeight;
      if (itemTop < containerTop || itemBottom > containerBottom) {
        container.scrollTop = itemTop - container.clientHeight / 2 + item.offsetHeight / 2;
      }
    }
  }, [menuList]);

  useEffect(() => {
    if (onSidebarToggle) onSidebarToggle(isOpen);
  }, []);

  const getAuditListing = async () => {
    let url = window.location.href;
    if (url.includes("audit-listing")) {
      try {
        const response = await apiCall(
          `${config.POSTLOGIN_API_URL_COMPANY}getAuditListing`,
          {}, { financialYearId: 30 }, "GET"
        );
        if (response.isSuccess && isMounted.current) {
          const data = response.data;
          const moduleNamesSet = new Set();
          const groupedData = data?.data?.reduce((acc, item) => {
            const moduleName = item.question?.moduleName || "Unknown Module";
            moduleNamesSet.add(moduleName);
            if (!acc["All Module"]) acc["All Module"] = [];
            acc["All Module"].push(item);
            if (!acc[moduleName]) acc[moduleName] = [];
            acc[moduleName].push(item);
            return acc;
          }, {});
          if (isMounted.current) setAuditModule(groupedData);
          setAuditModuleNames(Array.from(moduleNamesSet));
          setAuditAssignedTo(data.getAssignedDetails);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  const getSource = async () => {
    const { isSuccess, data } = await apiCall(
      `${config.POSTLOGIN_API_URL_COMPANY}getSource`, {}, {}, "GET"
    );
    if (isSuccess && isMounted.current) setSourceData(data?.data);
  };

  useEffect(() => {
    const storedSubMenu = JSON.parse(localStorage.getItem("subMenu"));
    setIsSubmenuVisible(storedSubMenu !== null ? storedSubMenu : false);
    const storedSubAuditMenu = JSON.parse(localStorage.getItem("subAuditMenu"));
    setIsAuditListingSubmenuVisible(storedSubAuditMenu !== null ? storedSubAuditMenu : false);
    const fetchData = async () => {
      try { await getReportingQuestions(); }
      catch (error) { console.error("Error fetching reporting questions:", error); }
    };
    fetchData();
    return () => { localStorage.removeItem("subMenu"); };
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (activeMenuRef.current && menuScrollRef.current) {
        const container = menuScrollRef.current;
        const item = activeMenuRef.current;
        container.scrollTop =
          item.offsetTop - container.clientHeight / 2 + item.offsetHeight / 2;
      }
    }, 150);
    return () => clearTimeout(timer);
  }, []);

  const currentPath = window.location.pathname;
  const isAuditChildActive = currentPath.includes("audit-listing") || currentPath.includes("audit-history");
  const isCarbonChildActive = currentPath.includes("carbon-footprinting");


  const toggleAuditListingSubmenu = () => {
    selectedItem = "audit";
    getSource();
    getAuditListing();
    const newVal = !isAuditRotated;
    localStorage.setItem("subAuditMenu", JSON.stringify(newVal));
    setIsAuditRotated(newVal);
  };

  const authValue = JSON.parse(localStorage.getItem("currentUser"));

  const toggleCarbonSubmenu = () => {
    selectedItem = "carbon";
    localStorage.removeItem("reportingQuestion");
    const newVal = !isCarbonSubMenuVisible;
    localStorage.setItem("subCarbonMenu", JSON.stringify(newVal));
    setIsCarbonSubMenuVisible(newVal);
    setIsCarbonRotated(newVal);
  };

  const fetchFrameworkApi = async () => {
    const { isSuccess, data } = await apiCall(
      `${config.POSTLOGIN_API_URL_COMPANY}getFramework`, {}, { type: "ALL" }
    );
    if (isSuccess && isMounted.current) {
      const frameworkIds = data?.data.map((item) => item.id);
      setFrameworkValue(frameworkIds);
      return frameworkIds;
    }
  };

  const toUrlFriendlyName = (name) => name.toLowerCase().replace(/\s+/g, '-');

  const getFinancialYear = async () => {
    const storedData = localStorage.getItem('financialYearData');
    if (storedData && isMounted.current) {
      return JSON.parse(storedData).at(-1)?.id;
    }
    const { isSuccess, data } = await apiCall(
      `${config.POSTLOGIN_API_URL_COMPANY}getFinancialYear`, {}, {}
    );
    if (isSuccess && isMounted.current) {
      localStorage.setItem('financialYearData', JSON.stringify(data.data));
      return data?.data.at(-1)?.id;
    }
  };

  const getReportingQuestions = async () => {
    let url = window.location.href;
    if (url.includes("reporting-modules")) {
      const financialYearId = await getFinancialYear();
      const frameworkIds = await fetchFrameworkApi();
      if (!(financialYearId && frameworkIds)) return;
      try {
        const response = await apiCall(
          `${config.POSTLOGIN_API_URL_COMPANY}getReportingQuestion`,
          {}, { financialYearId, frameworkIds }, "GET"
        );
        if (response.isSuccess && isMounted.current) {
          const data = response.data;
          setModuleNames([...new Set(data.data.map(item => item.moduleName))]);
          const groupedByModuleName = data?.data?.reduce((acc, item) => {
            if (!acc["All Module"]) acc["All Module"] = [];
            acc["All Module"].push(item);
            if (!acc[item.moduleName]) acc[item.moduleName] = [];
            acc[item.moduleName].push(item);
            return acc;
          }, {});
          setModule(groupedByModuleName);
          setAssignedTo(data.assignedDetail);
          localStorage.setItem("subMenu", JSON.stringify(true));
          setIsSubmenuOpen(true);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  useEffect(() => {
    const settingsMenu = JSON.parse(localStorage.getItem("menu"));
    fetchFrameworkApi();
    setMenuList(settingsMenu);
  }, [contextType.state]);

  const logoutUser = async () => {
    await apiCall(`${config.POSTLOGIN_API_URL_COMPANY}logout`, {}, {}, 'POST');
  };

  const logout = () => {
    logoutUser();
    authenticationService.logout();
    history.push("/");
    localStorage.clear();
  };

  const currentURL = window.location.href;
  const splitURL = currentURL.split("/");
  const activeURL = splitURL[4];
  const isReportingModuleActive = activeURL === 'reporting-modules' || activeURL.startsWith('reporting-modules/');

  const toggle = () => {
    selectedItem = "overview";
    setIsSubmenuVisible(false);
    localStorage.setItem("subMenu", JSON.stringify(false));
    localStorage.setItem("subAuditMenu", JSON.stringify(false));
  };

  const [isOpen, setIsOpen] = useState(
    () => JSON.parse(localStorage.getItem("sidebarOpen") ?? "true")
  );

  const toggleSidebar = () => {
    const newState = !isOpen;
    setIsOpen(newState);
    localStorage.setItem("sidebarOpen", JSON.stringify(newState));
    if (onSidebarToggle) onSidebarToggle(newState);
  };

  const handleMenuClick = (data, e) => {
    if (data?.isDisabled) { e.preventDefault(); return; }
    if (authValue.company_id === 349) {
      if (data.caption === "Chatbot") {
        e.preventDefault();
        window.location.href = "https://riu-webui.riu.ai";
        return;
      }
      if (data.caption === "Competitor Analysis") {
        e.preventDefault();
        window.location.href = "https://brsrdashboard-gba9b3d2h3e4fdfs.centralindia-01.azurewebsites.net/";
        return;
      }
    }
    toggle();
  };

  // helper to attach activeMenuRef to the currently active li
  const getActiveRef = (isActive) => isActive ? activeMenuRef : null;

  return (
    <div style={{ boxSizing: "border-box", width: "100%", height: "100vh", overflowY: "auto" }}>
      <div className="d-flex p-10" id="wrapper" style={{ boxSizing: "border-box", width: "100%", maxWidth: "100%", height: "100%" }}>
        <div
          className={`bg-white d-flex flex-column h-100 position-relative ${isOpen ? "sidebar-expanded" : "sidebar-collapsed"}`}
          style={{
            transition: "width 0.3s ease",
            width: isOpen ? "100%" : "60px",
            overflow: "hidden",
            minHeight: 0
          }}
        >
          {/* Logo row — contains toggle button on the right */}
          <div style={{
            display: "flex",
            alignItems: "center",
            justifyContent: isOpen ? "space-between" : "center",
            padding: "8px 12px",
            minHeight: "80px",
            flexShrink: 0,
            overflow: "visible",
          }}>
            {/* Logo — hidden when collapsed */}
            <NavLink to="/home" style={{ display: isOpen ? "block" : "none" }}>
              <img src={head_Logo} alt="Logo" style={{ maxWidth: "160px" }} />
            </NavLink>

            {/* Toggle button — always visible, sits at right of logo row */}
            <button
              onClick={toggleSidebar}
              className="toggle-btn"
              style={{
                position: "absolute",
                right: "8px",
                top: "22px",
                zIndex: 1000,
                cursor: "pointer",
                width: "32px",
                height: "32px",
                borderRadius: "50%",
                border: "1px solid #ddd",
                background: "#3f88a5",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                color: "#fff",
                fontSize: "20px",
                flexShrink: 0,
              }}
            >
              <FiSidebar />
            </button>
          </div>

          <div className="sidebar-content">
            <div className="list-group list-group-flush">
              <div className="route-dom p-2">

                {/* Dashboards section — not scrollable */}
                {menuList?.some(item => item.url === "home") && (
                  <div className="overView">
                    <div style={{ paddingLeft: "5%", paddingRight: "5%", paddingBottom: "2%", borderRadius: 8, flexDirection: "column", justifyContent: "center", alignItems: "flex-start", display: "inline-flex" }}>
                      <div style={{ alignSelf: "stretch", color: "rgba(28, 28, 28, 0.40)", fontSize: 14, fontFamily: "Open Sans", fontWeight: "400", wordWrap: "break-word" }}>
                        Dashboards
                      </div>
                    </div>
                    <ul className="home_icon_img">
                      {menuList?.filter(item => item.url === "home").map((data, index) => (
                        <li key={index}>
                          <NavLink activeClassName="active" onClick={(e) => handleMenuClick(data, e)} to={`/${data?.url}`} className="list-group-item list-group-item-action list-group-item-light p-3 nop">
                            <span className="sidebar-icon-wrap">
                              <img className="icon-inactive" src={`/sidebar-icons/${data?.inactiveIcon}`} width={32} height={32} alt="" />
                              <img className="icon-active" src={`/sidebar-icons/${data?.activeIcon}`} width={32} height={32} alt="" />
                            </span>
                            <span className="home_boom">Dashboards</span>
                          </NavLink>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                {/* Pages label — NOT inside scroll area */}
                <div className="pages-label" style={{ paddingLeft: "5%", paddingRight: "5%", paddingBottom: "2%", borderRadius: 8, flexDirection: "column", justifyContent: "center", alignItems: "flex-start", display: "inline-flex" }}>
                  <div style={{ alignSelf: "stretch", color: "rgba(28, 28, 28, 0.40)", fontSize: 14, fontFamily: "Open Sans", fontWeight: "400", wordWrap: "break-word" }}>
                    Pages
                  </div>
                </div>

                {/* Only the ul scrolls */}
                <div className="pages" ref={menuScrollRef}>
                  <ul className="home_icon_img">
                    {menuList?.filter(item => item.url !== "home")?.map((data, index) => {

                      if (data.caption === "Reporting Module") {
                        const isActive = isReportingModuleActive;
                        return (
                          <li key={index} ref={isActive ? activeMenuRef : null}>
                            <NavLink
                              to={`/reporting-modules/${toUrlFriendlyName('all-module')}`}
                              onClick={toggle}
                              className={`list-group-item list-group-item-action list-group-item-light nop ${isActive ? 'active' : ''}`}
                              activeClassName="active"
                              style={{ padding: "0.65rem" }}
                            >
                              <span className="sidebar-icon-wrap">
                                <img className="icon-inactive" src={`/sidebar-icons/${data?.inactiveIcon}`} width={32} height={32} alt="" />
                                <img className="icon-active" src={`/sidebar-icons/${data?.activeIcon}`} width={32} height={32} alt="" />
                              </span>
                              <span className="home_boom">{data.caption}</span>
                            </NavLink>
                          </li>
                        );
                      }

                      if (data.caption === "Audit") {
                        const isAuditDisabled = !!data?.isDisabled;
                        return (
                          <li key={index} ref={isAuditChildActive ? activeMenuRef : null}>
                            <div
                              onClick={() => {
                                if (isAuditDisabled) return;
                                if (!isOpen) {
                                  setIsOpen(true);
                                  if (onSidebarToggle) onSidebarToggle(true);
                                  const newVal = true;
                                  localStorage.setItem("subAuditMenu", JSON.stringify(newVal));
                                  setIsAuditRotated(newVal);
                                } else {
                                  toggleAuditListingSubmenu();
                                }
                              }}
                              className="audit-module list-group-item-action list-group-item-light nop"
                              style={{ display: "flex", alignItems: "center", borderRadius: "5px", transition: 'background-color 0.3s ease', cursor: isAuditDisabled ? "not-allowed" : "pointer" }}
                            >
                              <span className="sidebar-icon-wrap">
                                <img className="icon-inactive" src={`/sidebar-icons/${data?.inactiveIcon}`} width={32} height={32} alt="" />
                                <img className="icon-active" src={`/sidebar-icons/${data?.activeIcon}`} width={32} height={32} alt="" />
                              </span>
                              <span className="home_boom" style={isAuditDisabled ? { color: "#999" } : {}}>{data?.caption}</span>
                              {isAuditDisabled ? (
                                isOpen && <span style={{ marginLeft: "auto", color: "#bbb", display: "flex", alignItems: "center" }}><LockIcon /></span>
                              ) : (
                                <div style={{ marginLeft: "auto", color: "#3F88A5", transform: isAuditRotated ? 'rotate(0deg)' : 'rotate(90deg)', transition: 'transform 0.3s ease', display: "flex", alignItems: "center" }}>
                                  <svg width="15" height="8" viewBox="0 0 23 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path stroke="currentColor" d="M8.73823 9.70349C9.0194 9.95308 9.33455 10 9.50032 10C9.68532 10 9.97862 9.9545 10.2614 9.70349L18.7262 1.54155C19.1137 1.16804 19.0866 0.58669 18.666 0.242975C18.245 -0.100919 17.5903 -0.0759709 17.2033 0.296641L9.5 7.72292L1.79695 0.296641C1.40913 -0.0770478 0.754206 -0.10074 0.334037 0.242975C-0.0865365 0.58669 -0.113631 1.16804 0.27358 1.54155L8.73823 9.70349Z" />
                                  </svg>
                                </div>
                              )}
                            </div>
                            {(isAuditDisabled || isAuditRotated) && (
                              <ul className="submenu" style={{ marginTop: "6px" }}>
                                <li className="submenu-item">
                                  {isAuditDisabled ? (
                                    <div className="list-group-item list-group-item-action list-group-item-light nop" style={{ display: "flex", alignItems: "center", gap: 8, padding: "5px 12px", cursor: "not-allowed"}}>
                                      <svg className="submenu-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"/><rect x="9" y="3" width="6" height="4" rx="1"/><path d="M9 12h6M9 16h4"/></svg>
                                      <span style={{ flex: 1, color: "#999" }}>Audit Listing</span>
                                      <span style={{ color: "#bbb", display: "flex", alignItems: "center" }}><LockIcon /></span>
                                    </div>
                                  ) : (
                                    <NavLink to={{ pathname: `/audit-listing/${toUrlFriendlyName('All Module')}`, state: { auditModuleData: auditModule['All Module'], auditAssignedTo, sourceData } }} className="list-group-item list-group-item-action list-group-item-light nop">
                                      <svg className="submenu-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"/><rect x="9" y="3" width="6" height="4" rx="1"/><path d="M9 12h6M9 16h4"/></svg><span>Audit Listing</span>
                                    </NavLink>
                                  )}
                                </li>
                                <li className="submenu-item">
                                  {isAuditDisabled ? (
                                    <div className="list-group-item list-group-item-action list-group-item-light nop" style={{ display: "flex", alignItems: "center", gap: 8, padding: "5px 12px", cursor: "not-allowed"}}>
                                      <svg className="submenu-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 15 15"/></svg>
                                      <span style={{ flex: 1, color: "#999" }}>Audit History</span>
                                      <span style={{ color: "#bbb", display: "flex", alignItems: "center" }}><LockIcon /></span>
                                    </div>
                                  ) : (
                                    <NavLink to="/audit-history" className="list-group-item list-group-item-action list-group-item-light nop">
                                      <svg className="submenu-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 15 15"/></svg><span>Audit History</span>
                                    </NavLink>
                                  )}
                                </li>
                              </ul>
                            )}
                          </li>
                        );
                      }

                      if (data.caption === "Carbon Footprinting") {
                        const isCarbonDisabled = !!data?.isDisabled;
                        return (
                          <li key={index} ref={isCarbonChildActive ? activeMenuRef : null}>
                            <div
                              onClick={() => {
                                if (isCarbonDisabled) return;
                                if (!isOpen) {
                                  setIsOpen(true);
                                  if (onSidebarToggle) onSidebarToggle(true);
                                  const newVal = true;
                                  localStorage.setItem("subCarbonMenu", JSON.stringify(newVal));
                                  setIsCarbonSubMenuVisible(newVal);
                                  setIsCarbonRotated(newVal);
                                } else {
                                  toggleCarbonSubmenu();
                                }
                              }}
                              className="audit-module list-group-item-action list-group-item-light nop"
                              style={{ display: "flex", alignItems: "center", borderRadius: "5px", transition: 'background-color 0.3s ease', cursor: isCarbonDisabled ? "not-allowed" : "pointer" }}
                            >
                              <span className="sidebar-icon-wrap">
                                <img className="icon-inactive" src={`/sidebar-icons/${data?.inactiveIcon}`} width={32} height={32} alt="" />
                                <img className="icon-active" src={`/sidebar-icons/${data?.activeIcon}`} width={32} height={32} alt="" />
                              </span>
                              <span className="home_boom" style={isCarbonDisabled ? { color: "#999" } : {}}>{data?.caption}</span>
                              {isCarbonDisabled ? (
                                isOpen && <span style={{ marginLeft: "auto", color: "#bbb", display: "flex", alignItems: "center" }}><LockIcon /></span>
                              ) : (
                                <div style={{ marginLeft: "auto", color: "#3F88A5", transform: isCarbonRotated ? 'rotate(0deg)' : 'rotate(90deg)', transition: 'transform 0.3s ease', display: "flex", alignItems: "center" }}>
                                  <svg width="15" height="8" viewBox="0 0 23 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path stroke="currentColor" d="M8.73823 9.70349C9.0194 9.95308 9.33455 10 9.50032 10C9.68532 10 9.97862 9.9545 10.2614 9.70349L18.7262 1.54155C19.1137 1.16804 19.0866 0.58669 18.666 0.242975C18.245 -0.100919 17.5903 -0.0759709 17.2033 0.296641L9.5 7.72292L1.79695 0.296641C1.40913 -0.0770478 0.754206 -0.10074 0.334037 0.242975C-0.0865365 0.58669 -0.113631 1.16804 0.27358 1.54155L8.73823 9.70349Z" />
                                  </svg>
                                </div>
                              )}
                            </div>
                            {(isCarbonDisabled || isCarbonSubMenuVisible) && (
                              <ul className="submenu" style={{ marginTop: "6px" }}>
                                {[
                                  { label: "Scope 1", path: "/carbon-footprinting/scope-1", icon: <svg className="submenu-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2c0 0-5 5-5 10a5 5 0 0 0 10 0c0-5-5-10-5-10z"/></svg> },
                                  { label: "Scope 2", path: "/carbon-footprinting/scope-2", icon: <svg className="submenu-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg> },
                                  { label: "Scope 3", path: "/carbon-footprinting/scope-3", icon: <svg className="submenu-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15 15 0 0 1 4 10 15 15 0 0 1-4 10 15 15 0 0 1-4-10 15 15 0 0 1 4-10z"/></svg> },
                                ].map((scope) => (
                                  <li key={scope.label} className="submenu-item">
                                    {isCarbonDisabled ? (
                                      <div className="list-group-item list-group-item-action list-group-item-light nop" style={{ display: "flex", alignItems: "center", gap: 8, padding: "5px 12px", cursor: "not-allowed"}}>
                                        {scope.icon}
                                        <span style={{ flex: 1, color: "#999" }}>{scope.label}</span>
                                        <span style={{ color: "#bbb", display: "flex", alignItems: "center" }}><LockIcon /></span>
                                      </div>
                                    ) : (
                                      <NavLink to={{ pathname: scope.path, state: {} }} className="list-group-item list-group-item-action list-group-item-light nop">
                                        {scope.icon}<span>{scope.label}</span>
                                      </NavLink>
                                    )}
                                  </li>
                                ))}
                              </ul>
                            )}
                          </li>
                        );
                      }

                      return (
                        <li key={index} ref={activeURL === data?.url ? activeMenuRef : null}>
                          <NavLink
                            activeClassName="active"
                            onClick={(e) => handleMenuClick(data, e)}
                            to={`/${data?.url}`}
                            className="list-group-item list-group-item-action list-group-item-light nop"
                            style={{ padding: "0.65rem", cursor: data?.isDisabled ? "not-allowed" : "pointer" }}
                          >
                            <span className="sidebar-icon-wrap">
                              <img className="icon-inactive" src={`/sidebar-icons/${data?.inactiveIcon}`} width={32} height={32} alt="" />
                              <img className="icon-active" src={`/sidebar-icons/${data?.activeIcon}`} width={32} height={32} alt="" />
                            </span>
                            <span className="home_boom" style={data?.isDisabled ? { color: "#999" } : {}}>{data.caption}</span>
                            {isOpen && data?.isDisabled && (
                              <span style={{ marginLeft: "auto", color: "#bbb", display: "flex", alignItems: "center" }}><LockIcon /></span>
                            )}
                          </NavLink>
                        </li>
                      );
                    })}

                    <li>
                      <NavLink to="/" onClick={logout} isActive={() => false} className="list-group-item list-group-item-action list-group-item-light nop" style={{ padding: "0.65rem" }}>
                        <span className="sidebar-icon-wrap">
                          <img className="icon-inactive" src={`/sidebar-icons/logout-inactive.svg`} width={32} height={32} alt="" />
                          <img className="icon-active" src={`/sidebar-icons/logout.svg`} width={32} height={32} alt="" />
                        </span>
                        <span className="home_boom">Logout</span>
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;